import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as sisMapActions from "store/modules/rds_sisMap";
import $ from "jquery";
import { LoadingContext } from "../../loadingContext";

import "./realEstate.scss";
import stl from "../../modal/realEstate/AtpModal.module.scss";

import { IoIosArrowForward } from "react-icons/io";
import { MdClose } from "react-icons/md";

import SisSelect from "store/sis/component/SisSelect";
import SisOverlay from "store/sis/SisOverlay";

class RealEstate extends Component {
	static contextType = LoadingContext; // contextType 사용

	
	state = {
		title: "부동산",
		activeItem: "",
		lstEmd: [],
		lstYmd: [],
		lstGb: [],
		source:"",
	};

	openSearchWrap = (evt) => {
		$("#realEstateWrap .itemsWrap").hide();
		$("#realEstateWrap .searchWrap").show();
		$("#realEstateWrap .close").show();
		$(".source").show();
		$("#realEstateWrap .searchWrap").css("top","60px");		

		const id = $(evt.target).closest(".item").attr("id");
		const title = $(evt.target).closest(".item").find("span").text();
		let source = "";	

		this.selectRealEstateSgg.refresh();

		

		if(id=="oldApart"){
			this.getYmd("old_apart");		
			//this.getGb(id);
			source ="주택정책과";
		}else if(id=="apart"){
			
			source ="국토교통부";
		}else if(id=="officetel"){
			
			source ="국토교통부";
		}else if(id=="housing"){
			
			source ="국토교통부";
		}
		this.setState({
			activeItem: id,
			title,
			source,
		});
	};

	closeSearchWrap = (evt) => {
		$("#realEstateWrap .searchWrap").hide();
		$("#realEstateWrap .itemsWrap").show();
		$("#apartModal .close").click();
		$("#realEstateWrap .close").hide();
		$(".source").hide();
		$("#realEstateWrap .searchWrap").css("top","");

		$(".tabWrap .tab.active .searchWrap .listWrap").remove();

		this.setState({
			activeItem: "",
			title: "부동산",
		});
	};

	// 읍면동 불러오기
	getEmd = (value) => {
		let lstEmd = [];

		$.ajax({
			url: "/map/getEmd",
			type: "post",
			data: {
				value,
			},
			success: (res) => {
				lstEmd = res;

				this.setState({
					lstEmd: [{ emdCd: "0", emdNm: "=== 전체 ===" }, ...lstEmd],
				});
			},
		});
	};

	//년도 가져오기
	getYmd = (value) => {
		let lstYmd = [];

		$.ajax({
			url: "/map/getYmd",
			type: "post",
			data: {
				value,
			},
			success: (res) => {
				
				lstYmd = res;

				this.setState({
					lstYmd: [...lstYmd],
				});
			},
		});
	};

	//그룹 가져오기
	getGb = (id) => {
		let lstGb = [];

		if(id==="park"){
			lstGb = [
				{facilitiesGb:'근린공원',facilitiesNm:'근린공원'}, 
				{facilitiesGb:'소공원', facilitiesNm:'소공원'},
				{facilitiesGb:'어린이공원', facilitiesNm:'어린이공원'},
				{facilitiesGb:'주제공원', facilitiesNm:'주제공원'}
			];
		}
		this.setState({
			lstGb: [{ facilitiesGb: "0", facilitiesNm: "=== 전체 ===" }, ...lstGb],
		});		
	};

	// 오버레이 클릭 이벤트(모달창 띄움)
	_overlayClickEvent = (ele, id, activeItem, noProps = false,mapZoom = false) => {
		const { actions, layout, sis } = this.props;
		let overlayElement;
		let col;

		// console.log(`id ===> ${id}`);
		// console.log(`activeItem ===> ${activeItem}`);
		// // console.log(`element ===> ${ele}`);

		if (activeItem === "apart") {
			col = `addrDesc`;
		} else if (activeItem === "officetel") {
			col = `buildNm`;
		} else if (activeItem === "housing") {
			col = "buildNm";
		} else if (activeItem === "oldApart") {
			col = "aptName";
		}

		if ("apart,officetel,housing".indexOf(activeItem) > -1) {
			const modal = layout.get("realEstateModal");
			console.log("modal 값 확인:", modal);

			const arrYear = ele.stdYear ? ele.stdYear.split(",") : [];
			const arrMonth = ele.stdMonth ? ele.stdMonth.split(",") : [];
			const arrDay = ele.stdDay ? ele.stdDay.split(",") : [];
			const arrArea = ele.exclusiveArea ? ele.exclusiveArea.split(",") : [];
			const arrPrice = ele.salePrice ? ele.salePrice.split("|") : [];
			const arrFloor = ele.floorNum ? ele.floorNum.split(",") : [];

			const areaGroup = [];

			arrArea.forEach((area) => {
				if (!areaGroup.includes(area)) areaGroup.push(area);
			});

			modal.setContents(
				<div className={stl.contentWrapper}>
					<table className={stl.srchTable}>
						<caption>계약 정보</caption>
						<thead>
							<tr>
								<td className={stl.title}>지번주소</td>
								<td className={stl.data}>
									{ele.jibunAddr} ({ele[col]}){ele.roadAddr ? " / " + ele.roadAddr : ""}
								</td>
							</tr>
						</thead>
					</table>
					<div className={stl.searchWrapper}>
						<label style={{ width: "104px", display: "inline-block", textAlign: "center" }}>전용면적</label>
						<select
							style={{ marginLeft: "0px" }}
							onChange={(evt) => {
								$(`tr.${stl.dataList}`).show();

								$(`tbody tr.${stl.dataList}`).show();
								if (evt.target.value !== "all") $(`tbody tr:not(.area${evt.target.value.replace(".", "")})`).hide();
							}}
						>
							<option value="all">전체</option>
							{areaGroup.map((area, idx) => {
								return (
									<option value={area} key={idx}>
										{area}
									</option>
								);
							})}
						</select>
					</div>
					<table className={stl.rsltTable}>
						<caption>계약정보</caption>
						<thead>
							<tr>
								<th>계약월</th>
								<th>계약일</th>
								<th>전용면적(㎡)</th>
								<th>거래금액(만원)</th>
								<th>층</th>
							</tr>
						</thead>
						<tbody>
							{arrYear.map((item, idx) => {
								return (
									<tr className={`${stl.dataList} area${arrArea[idx].replace(".", "")}`} key={idx}>
										<td>
											{item}.{arrMonth[idx]}
										</td>
										<td>{arrDay[idx]}</td>
										<td>{arrArea[idx]}</td>
										<td>{arrPrice[idx]}</td>
										<td>{arrFloor[idx]}</td>
									</tr>
								);
							})}
						</tbody>
					</table>
				</div>
			);
			modal.show();
			if(mapZoom){
				const feature = sis.sisLayer.createFeatureByWKT(ele.geom);
				feature.getGeometry().transform("EPSG:5186", "EPSG:5181");
				sis.sisMap.view.fit(feature.getGeometry().getExtent());
			}
			
		} else if(activeItem == "oldApart"){
			overlayElement = (
				<>
					<div
						className="sisOverlayClose"
						onClick={() => {
							$(`#${id}`).remove();
						}}
					>
						<MdClose size="25px" />
					</div>

					<span className="realEstateTitle">{ele.aptName}</span>
					<span className="realEstateAddress">{ele.aptDong ? ele.cnvnncFclty : "-"} {ele.roadAddres ? ele.roadAddres : "-"}</span>
					<table>
						<caption>세대수</caption>
						<tbody>
							<tr>
								<th>전용면적(㎡)</th>
								<td>{ele.area ? ele.area : "-"}</td>
							</tr>
							<tr>
								<th>세대수</th>
								<td>{ele.houseCnt ? ele.houseCnt : "-"}</td>
							</tr>
							<tr>
								<th>세대수 합</th>
								<td>{ele.houseTotal ? ele.houseTotal : "-"}</td>
							</tr>
							<tr>
								<th>층수</th>
								<td>{ele.floorNum ? ele.floorNum : "-"}</td>
							</tr>
							<tr>
								<th>공급형태</th>
								<td>{ele.supplyType ? ele.supplyType : "-"}</td>
							</tr>
							<tr>
								<th>사용검사연도</th>
								<td>{ele.checkYear ? ele.checkYear : "-"}</td>
							</tr>
						</tbody>
					</table>
				</>
			);

			if(mapZoom){
				const feature = sis.sisLayer.createFeatureByWKT(ele.geom);
				feature.getGeometry().transform("EPSG:5186", "EPSG:5181");
				sis.sisMap.view.fit(feature.getGeometry().getExtent());
			}

			let overlay = sis.sisMap.map.getOverlayById("overlaySelector");
			sis.sisMap.map.removeOverlay(overlay);

			actions.addResultOverlay({
				element: overlayElement,
				data: ele,
				id,
				className: "removeOverlayWrap",
				isTop: true,
				noProps,
			});
		} else {
			overlayElement = (
				<>
					<div
						className="sisOverlayClose"
						onClick={() => {
							$(`#${id}`).remove();
						}}
					>
						<MdClose size="25px" />
					</div>

					<span className="realEstateTitle">{ele.companyNm}</span>
					<span className="realEstateAddress">{ele.addr}</span>
					<span>대표자 : {ele.delegate}</span>
					<span>전화번호 : {ele.tel}</span>
				</>
			);

			let overlay = sis.sisMap.map.getOverlayById("overlaySelector");
			sis.sisMap.map.removeOverlay(overlay);

			actions.addResultOverlay({
				element: overlayElement,
				data: ele,
				id,
				className: "removeOverlayWrap",
				isTop: true,
				noProps,
				mapZoom,
			});
			
		}
		
	};

	// 오버레이 클릭 이벤트(겹치는거 확인)
	overlayClickEvent = (ele, evt, overlay) => {
		const { actions, layout, sis } = this.props;

		let col = "";
		const activeItem = $(evt.target).closest(".sisOverlayWrap").find("span:first").attr("class");
		const id = `realEstate_${activeItem}_removeOverlay`;
		$(`#${id}`).remove();

		if (activeItem === "apart") {
			col = `addrDesc`;
		} else if (activeItem === "officetel") {
			col = `buildNm`;
		} else if (activeItem === "housing") {
			col = "buildNm";
		}else if (activeItem === "oldApart") {
			col = "aptName";
		} else {
			col = `companyNm`;
		}

		const arrOverlays = [];
		const pos = overlay.getPosition();
		const interval = 1;
		let xInterval = 0;
		let yInterval = 0;
		const overlays = sis.sisMap.map.getOverlays().getArray();

		$.each(overlays, (idx, item) => {
			let targetPos = item.getPosition();

			if (targetPos) {
				targetPos = targetPos;

				xInterval = Math.abs(pos[0] - targetPos[0]);
				yInterval = Math.abs(pos[1] - targetPos[1]);

				if (xInterval <= interval && yInterval <= interval) {
					arrOverlays.push(item);
				}
			}
		});

		if (arrOverlays.length > 1) {
			// if (true) {
			// 오버레이 생성
			const overlayElement = document.createElement("div");
			document.body.appendChild(overlayElement);
			overlayElement.className = "overlaySelector";
			overlayElement.id = "overlaySelector";

			let overlay = sis.sisMap.map.getOverlayById("overlaySelector");

			if (overlay) sis.sisMap.map.removeOverlay(overlay);
			overlay = new SisOverlay(`#overlaySelector`, sis.sisMap.map, "bottom-center", [0, 0]);
			overlay.setPosition(pos);
			$(overlayElement).parent().css("z-index", 9999);

			arrOverlays.forEach((item) => {
				const props = item.getProperties();

				if (props[col]) {
					const element = document.createElement("div");

					if (activeItem === "property") {
						element.innerText = props[col];
					} else if (activeItem === "oldApart") {
						element.innerText = props[col];
					} else {
						element.innerText = props[col] + ` (${props.roadAddr})`;
					}

					$(overlayElement).append(element);

					$(element).on("click", () => {
						this._overlayClickEvent(props, id, activeItem, true);
						sis.sisMap.map.removeOverlay(overlay);
					});
				}

				// $(overlayElement).append(`<div>${props.buildNm}</div>`);
			});
		} else {
			this._overlayClickEvent(ele, id, activeItem);
		}

		return;
	};

	// 오버레이 생성
	createOverlay = (data, id) => {
		const { actions } = this.props;
		const { activeItem } = this.state;

		$(".tabWrap .tab.active .searchWrap .listWrap").remove();
		$(".tabWrap .tab.active .searchWrap").append("<div class='listWrap'><span class='cnt'>검색결과 <a>" + data.length.toLocaleString() + "</a>건</span></div>");

		data.forEach((ele, idx) => {
			let overlayElement;
			let overlayId = "";
			let crsCode = "EPSG:5186";

			if (activeItem === "apart") {
				overlayId = `${id}_${ele.pnu}_${idx}`;
				overlayElement = (
					<>
						<span className={activeItem}>{ele.addrDesc}</span>
					</>
				);

				//$(".tabWrap .tab.active .searchWrap .listWrap").append(`<span class=lst_${overlayId}>${ele.addrDesc}${ele.roadAddr ? " (" + ele.roadAddr + ")" : ""}</span>`);
			} else if (activeItem === "officetel") {
				overlayId = `${id}_${ele.pnu}`;
				overlayElement = (
					<>
						<span className={activeItem}>{ele.buildNm}</span>
					</>
				);
				//$(".tabWrap .tab.active .searchWrap .listWrap").append(`<span class=lst_${overlayId}>${ele.buildNm}${ele.roadAddr ? " (" + ele.roadAddr + ")" : ""}</span>`);
			} else if (activeItem === "housing") {
				overlayId = `${id}_${ele.pnu}`;
				overlayElement = (
					<>
						<span className={activeItem}>{ele.buildNm}</span>
					</>
				);
				//$(".tabWrap .tab.active .searchWrap .listWrap").append(`<span class=lst_${overlayId}>${ele.buildNm}${ele.roadAddr ? " (" + ele.roadAddr + ")" : ""}</span>`);
			} else if (activeItem === "oldApart") {
				overlayId = `${id}_${ele.gid}`;
				overlayElement = (
					<>
						<span className={activeItem}>{ele.aptName}</span>
					</>
				);
				//$(".tabWrap .tab.active .searchWrap .listWrap").append(`<span class=lst_${overlayId}>${ele.aptName}</span>`);
			}

			
			actions.addResultOverlay({
				element: overlayElement,
				data: ele,
				id: overlayId,
				crsCode,
				className: "realEstateOverlayWrap",
				onClick: this.overlayClickEvent,
				minZoom: 6,
				maxZoom: 10,
			});
		});

		// 오버레이 클릭 이벤트
		data.forEach((ele, idx) => {
			let overlayElement;
			if (activeItem==="apart") {
				//$(".tabWrap .tab.active .searchWrap .listWrap").append(`<span class=lst_${id}_${ele.gid}>${ele.equipNm}</span>`);

				$(".tabWrap .tab.active .searchWrap .listWrap").append(
					`<span class="lst_${id}_${ele.gid}" 
						data-ele='${JSON.stringify(ele).replace(/'/g, "&apos;")}' 
						data-id='${id}' 
						data-active-item='${activeItem}'>
					${ele.addrDesc}
					</span>`
				);
			} else if (activeItem==="officetel"){
				$(".tabWrap .tab.active .searchWrap .listWrap").append(
					`<span class="lst_${id}_${ele.gid}" 
						data-ele='${JSON.stringify(ele).replace(/'/g, "&apos;")}' 
						data-id='${id}' 
						data-active-item='${activeItem}'>
					${ele.buildNm}
					</span>`
				);
			}	else if (activeItem==="housing"){
				$(".tabWrap .tab.active .searchWrap .listWrap").append(
					`<span class="lst_${id}_${ele.gid}" 
						data-ele='${JSON.stringify(ele).replace(/'/g, "&apos;")}' 
						data-id='${id}' 
						data-active-item='${activeItem}'>
					${ele.buildNm}
					</span>`
				);
			}else if (activeItem==="oldApart"){
				$(".tabWrap .tab.active .searchWrap .listWrap").append(
					`<span class="lst_${id}_${ele.gid}" 
						data-ele='${JSON.stringify(ele).replace(/'/g, "&apos;")}' 
						data-id='${id}' 
						data-active-item='${activeItem}'>
					${ele.aptName}
					</span>`
				);
			}

			
		});

		$(".tabWrap .tab.active .searchWrap .listWrap").on("click", "span", (event) => {
			const target = $(event.currentTarget);
		
			const eleAttr = target.attr("data-ele");
			const id = target.attr("data-id")+"_removeOverlay";
			const activeItem = target.attr("data-active-item");
		
			if (!eleAttr) {
				console.error("data-ele 값이 없습니다.");
				return;
			}
		
			try {
				// JSON.parse() 한 번만 실행
				const ele = JSON.parse(eleAttr);
				
				// `this._overlayClickEvent()`를 호출하도록 변경 (화살표 함수 덕분에 this 유지됨)
				if (typeof this._overlayClickEvent === "function") {
					const mapZoom = true;
					const noProps = false;
					this._overlayClickEvent(ele, id, activeItem,noProps,mapZoom);
				} else {
					console.error("_overlayClickEvent 함수가 존재하지 않습니다.");
				}
			} catch (error) {
				console.error("JSON 파싱 오류:", error);
			}
		});
		if(activeItem === "oldApart"){
			$(".tabWrap .tab.active .searchWrap .listWrap").css("top","230px");
		}
	};

	// 검색
	search = async (evt, id) => {
		const { setLoading } = this.context; // ✅ context에서 setLoading 가져오기
    	setLoading(true); 
		$(".layerOpen").css("display","block");
		const { activeItem } = this.state;
		const { actions, sis } = this.props;

		let stdYmd = document.querySelector("select#selectLivingStdYmd");
		// stdYmd 값을 select에서 직접 가져오기
		if (stdYmd) {
			stdYmd = stdYmd.value;
		} else {
			stdYmd = null;  // 요소가 없으면 기본값 null 설정
		}

		// 기준년도 값이 없으면 1초 대기 후 실행
		const waitForStdYmd = () => {
			return new Promise(resolve => {
			  if (!stdYmd || stdYmd.trim() === "") {
				//console.log("기준년도 값이 없습니다. 1초 대기 중...");
				// 1초 대기 후, resolve를 호출하여 대기 끝냄
				setTimeout(() => {
				  resolve(); // Promise를 해결하여 대기 종료
				}, 1000);
			  } else {
				//console.log("기준년도 값이 있습니다.");
				resolve(); // 바로 resolve하여 대기 없이 진행
			  }
			});
		  };
		
		  // 비동기적으로 처리할 함수
		  await waitForStdYmd(); // 기준년도 값이 없으면 1초 기다리기
		
		let title = "";
		let data = [];
		//let stdYmd = "";
		//let guBun = "0";
		if(activeItem==="oldApart"){
			stdYmd = $("select#selectRealEstateStdYmd").val() || $("select#selectRealEstateStdYmd option:first").val() || "0";
			//guBun = $("select#selectEnvironmentGb").val();
		}
		//if(guBun==null){
			//guBun = "0";
		//}
		let params = {
			sggCode: $("select#selectRealEstateSgg").val() || "0",
			emdCode: $("select#selectRealEstateEmd").val() || "0",
			stdYmd: stdYmd,
			//guBun: guBun,
		};

		
		let color = "#ff0000";
		let url = "";
		let legend = "";
		let crsCode = "EPSG:5186";

		if (activeItem === "apart") {
			title = "아파트(매매)실거래가";
			color = "rgb(102, 46, 155)";
			url = "/map/selectActuallyPriceApart";
		} else if (activeItem === "officetel") {
			title = "오피스텔(매매)실거래가";
			color = "rgb(234, 53, 70)";
			url = "/map/selectOfficetelPriceFlat";
		} else if (activeItem === "housing") {
			title = "연립(다세대)매매 실거래가";
			color = "#3f51b2";
			url = "/map/selectActuallyPriceFlat";
		} else if (activeItem === "oldApart") {
			title = "노후 아파트";
			color = "#3f51b2";
			url = "/map/selectOldApart";
		} else {
			title = "부동산 중개업소";
			color = "#3f51b5";
			url = "/map/selectRealEstate";
			crsCode = "EPSG:4326";
		}

		$.ajax({
			url,
			type: "post",
			data: params,
			success: (res) => {
				data = res.items ? res.items : res;

				if (data.length === 0) {
					alert("검색결과가 없습니다.");
					setLoading(false);
					return;
				}

				if (res.wkt) {
					const feature = sis.sisLayer.createFeatureByWKT(res.wkt);
					feature.getGeometry().transform("EPSG:5186", "EPSG:5181");
					const extent = feature.getGeometry().getExtent();

					sis.sisMap.view.fit(extent);
				}

				const lyr = sis.sisLayer.getLayerById(id);

				if (lyr) {
					actions.deleteResult({
						id,
						refresh: true,
					});
				}

				// 트리아이템 생성
				actions.addResultItem({
					data: legend,
					id,
					title,
					closeEvent: actions.deleteResult,
					checkboxEvent: actions.resultCheckboxHandler,
				});

				// 레이어 생성
				actions.addResultLayer({
					data,
					id,
					type: "point",
					color, 
					crsCode,
					callback: () => {
						requestAnimationFrame(() => {
							setLoading(false); 
						  });
					 }
				});

				// 오버레이 생성
				this.createOverlay(data, id);
			},
		});
	};

	render() {
		const { activeItem } = this.state;
		const { lstSgg, defaultSggCd } = this.props.sis;
		let searchElement;

		if ("oldApart".indexOf(activeItem) > -1) {
			searchElement = (
				<>
					<div className="inputWrap">
						<span className="selectTitle">기준년도</span>
						<SisSelect
							id="selectRealEstateStdYmd"
							ref={(ref) => (this.selectRealEstateStdYmd = ref)}
							className="select"
							mapping={{
								key: "stdYmd",
								text: "stdName",
							}}
							items={this.state.lstYmd}
						/>
					</div>
					<div className="inputWrap">
						<span className="selectTitle">구명</span>
						<SisSelect
							id="selectRealEstateSgg"
							ref={(ref) => (this.selectRealEstateSgg = ref)}
							className="select"
							items={lstSgg}
							mapping={{
								key: "sggCd",
								text: "sggNm",
							}}
							onChange={this.getEmd}
							onLoaded={this.getEmd}
						/>
					</div>
					<div className="inputWrap">
						<span className="selectTitle">동명</span>
						<SisSelect
							id="selectRealEstateEmd"
							className="select"
							mapping={{
								key: "emdCd",
								text: "emdNm",
							}}
							items={this.state.lstEmd}
						/>
					</div>

					<div className="btnWrap">
						<button id="btnSearch" onClick={(evt) => this.search(evt, activeItem)}>
							검색
						</button>
					</div>
				</>
			);
		 }else{
			searchElement = (
				<>
					<div className="inputWrap">
						<span className="selectTitle">구명</span>
						<SisSelect
							id="selectRealEstateSgg"
							ref={(ref) => (this.selectRealEstateSgg = ref)}
							className="select"
							items={lstSgg}
							mapping={{
								key: "sggCd",
								text: "sggNm",
							}}
							onChange={this.getEmd}
							onLoaded={this.getEmd}
						/>
					</div>
					<div className="inputWrap">
						<span className="selectTitle">동명</span>
						<SisSelect
							id="selectRealEstateEmd"
							className="select"
							mapping={{
								key: "emdCd",
								text: "emdNm",
							}}
							items={this.state.lstEmd}
						/>
					</div>

					<div className="btnWrap">
						<button id="btnSearch" onClick={(evt) => this.search(evt, activeItem)}>
							검색
						</button>
					</div>
				</>
			);
		 }

		return (
			<div id="realEstateWrap" className="contentsWrap">
				<div className="title">
					<span>{this.state.title}</span>
					<div className="close" onClick={this.closeSearchWrap}>
						<MdClose />
					</div>
				</div>
				<div className="source" style={{display:"none"}}>
					<span className="origin_tit">출처</span>
					<span className="origin_stxt">{this.state.source}</span>
				</div>
				<div className="itemsWrap">
					<div id="apart" className="item btn" onClick={this.openSearchWrap}>
						{/*<img className="logo" alt="아파트(매매) 실거래가" src="/sis/images/map/realEstate/icApart.png" />*/}
						<span>아파트(매매) 실거래가</span>
						<IoIosArrowForward className="arrow" />
					</div>

					<div id="officetel" className="item btn" onClick={this.openSearchWrap}>
						{/*<img className="logo" alt="오피스텔(매매) 실거래가" src="/sis/images/map/realEstate/icOfficetel.png" />*/}
						<span>오피스텔(매매) 실거래가</span>
						<IoIosArrowForward className="arrow" />
					</div>

					<div id="housing" className="item btn" onClick={this.openSearchWrap}>
						{/*<img className="logo" alt="연립(다세대)매매 실거래가" src="/sis/images/map/realEstate/icHousing.png" />*/}
						<span>연립(다세대)매매 실거래가</span>
						<IoIosArrowForward className="arrow" />
					</div>

					{/*<div id="property" className="item btn" onClick={this.openSearchWrap}>
						<img className="logo" alt="부동산 중개업소" src="/sis/images/map/realEstate/icProperty.png" />
						<span>부동산 중개업소</span>
						<IoIosArrowForward className="arrow" />
					</div>*/}

					<div id="oldApart" className="item btn" onClick={this.openSearchWrap}>
						{/*<img className="logo" alt="노후 아파트" src="/sis/images/map/realEstate/icProperty.png" />*/}
						<span>노후 아파트</span>
						<IoIosArrowForward className="arrow" />
					</div>
				</div>

				<div className="searchWrap">{searchElement}</div>
			</div>
		);
	}
}

export default connect(
	(state) => ({
		layout: state.layout,
		sis: state.sisMap,
	}),
	(dispatch) => ({
		actions: bindActionCreators(sisMapActions, dispatch),
	})
)(RealEstate);
